import React, { useState, useEffect, useContext } from 'react';
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import { useFormikContext } from "formik";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import UseFormikHelper from "../../../Utils/UseFormikHelper";


function TaxResidenceTable(props) {
  const { values,setFieldTouched } = useFormikContext();
  const [isInitialized, setIsInitialized] = useState(false);
  const applicationContext = useContext(KycApplicationContext);
  let isDisabled = applicationContext.disableForm;
  const { defaultValueFromOtherField, clearFieldValue } = UseFormikHelper();
  const [isProcessing, setIsProcessing] = useState(false);


  function deleteTableRows(event, index) {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if (isProcessing) return;
    setIsProcessing(true);
    clearRowValues(index);
    values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.splice(index,1);
    defaultValueFromOtherField(
      "personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails",
      "personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails"
    );
    if (props.onSaveToStore && typeof props.onSaveToStore === "function") {
      props.onSaveToStore(values);
    }
    setTimeout(() => {
      setIsProcessing(false);
    }, 5);
  }

  function addTableRows(event, index) {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if(isProcessing) return;
    setIsProcessing(true);
    setCurrentRowFieldsTouched(index);
    if (values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[index].countryOfTaxResidency !== null && values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[index].taxIdentificationNumber != "" && values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[index].taxIdentificationType != "" && values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[index].remarks != "") {
      arrayInitialization();
    }
    setIsProcessing(false); 
    
  }

  function setCurrentRowFieldsTouched(index) {
    setFieldTouched(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].countryOfTaxResidency`,true);
    setFieldTouched(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationNumber`,true);
    setFieldTouched(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationType`,true);
    setFieldTouched(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].remarks`,true);
  }

  function clearRowValues(index) {
    clearFieldValue(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].countryOfTaxResidency`,null);
    clearFieldValue(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationNumber`,"");
    clearFieldValue(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationType`,"");
    clearFieldValue(`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].remarks`,"");
  }

  function addDefaultFirstRow() {
    if (
      !values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails ||
      values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails
        .length == 0
    ) {
      values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails = [];
      arrayInitialization();
    }
  }

  function arrayInitialization() {
    const rowsInput = {
      countryOfTaxResidency: null,
      taxIdentificationNumber: "",
      taxIdentificationType: "",
      remarks: "",
    };
    values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.push(
      rowsInput
    )
    if(props.onSaveToStore && typeof(props.onSaveToStore)==='function'){
      props.onSaveToStore(values);
    }  

  }

  useEffect(() => {
    addDefaultFirstRow();
    setIsInitialized(true);
  }, []);
  return (
    <>
      {isInitialized && values.personalInfoDTO.taxDeclarationDTO && values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails &&
        values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.map((obj, index) => {
          return (
            <tr key={index} className="table_row">
            <td className="table-input-width">
                 <CsplAchField
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}

                  name={`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].countryOfTaxResidency`}
                  required={true}
                  disabled={isDisabled}
                  id="countriesOfTaxResidency"
                  className="my-2"
                  lookupName={props.countryLookupName}
                  displayColumn="name"
                />
              </td>             

              <td className='table-input-width p-3'> <CsplTextBoxField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }}
                name={`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationNumber`}
                required={true}
                disabled={isDisabled}
                id="taxId"
                className="my-2"
              /></td>
              <td className='table-input-width p-3'><CsplTextBoxField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }}
                name={`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].taxIdentificationType`}
                required={true}
                disabled={isDisabled}
                id="taxType"
                className="my-2"
              /> </td>

              <td className='table-input-width p-3'><CsplTextBoxField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }}
                name={`personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails[${index}].remarks`}
                required={true}
                disabled={isDisabled}
                id="remarks"
                className="my-2"
              /></td>
                {!applicationContext.disableForm &&
                <td className='table_action_btns p-3'> 
                  <button className="btn shadow-none tableremove_btn my-2 mx-2 mt-0" type="button" disabled={isProcessing}  > 
                  {values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.length > 1 &&<i className="bi bi-trash" onClick={(event) => (deleteTableRows(event, index))}></i> }
                  </button>
                  
                    <button type="button"
                      className="btn shadow-none tableadd_btn my-2 mt-0"
                      disabled={isProcessing}>
                      {(index === (values.personalInfoDTO.taxDeclarationDTO.taxResidencyCountryDetails.length - 1)) &&
                      <i className="bi bi-plus-circle"  onClick={(event) => addTableRows(event, index)}></i>
                    }
                    </button>
                </td>} 
            </tr>
          )
        })}
    </>

  )

}
export default TaxResidenceTable;
